import Vue from "vue";
import {store} from "./storage";
import {router} from "./router";
import MainHeader from "./modules/header/Header";
import {
    Dialog,
    Input,
    TabPane,
    Tabs,
    Checkbox,
    Popover,
    DropdownItem,
    Dropdown,
    DropdownMenu,
    Loading,
    Table,
    TableColumn,
    Switch, DatePicker
} from "element-ui";
import VueScrollTo from "vue-scrollto";
import mcMemories from "./modules/memories/MemoriesLanding";
import {AppNotify} from "./utils/app-notify";
import width from "./mixins/width";
import {DataLayer} from "./utils/data-layer";

Vue.use(Dialog);
Vue.use(Input);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(VueScrollTo);
Vue.use(Popover);
Vue.use(DropdownItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(Popover);
Vue.use(Loading.directive);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Switch);
Vue.use(DatePicker);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$optionsLoading = {customClass: 'loading', spinner: 'loading'};

Vue.mixin(width);

window.Vue = Vue;
window.axios = require('axios');

window.axios.interceptors.request.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if ((error.response.status === 403 && !window.laravel.user) || error.response.status === 401) {
        router.push({name: 'login'});
    }
    return Promise.reject(error);
});

window.Vue.use(AppNotify);
window.Vue.use(DataLayer);

new Vue({
    el: '#memories',
    store,
    router,
    data: () => ({
        menu: false,
        windowWidth: window.innerWidth,
    }),
    components: {
        MainHeader, mcMemories
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    }
});
